import React from "react";
import { useNavigate } from "react-router-dom";
import { qualityInspections } from "../services/qualityData";
import QualityTable from "../components/QualityTable";

const QualityList = () => {
    const navigate = useNavigate();

    const handleInspectPiece = () => {
        navigate("/inspect-piece");
    };

    return (
        <div className="max-w-6xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Contrôle qualité</h1>
            <QualityTable inspections={qualityInspections} />
            <button
                onClick={handleInspectPiece}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
                Inspecter une pièce
            </button>
        </div>
    );
};

export default QualityList;
